/**
 * Group locale API wrapper — `GET /groups/:id/locale`.
 *
 * A FE az aktív csoport váltásakor lekéri, és a `useAuth().activeGroupLocale`
 * exposed státuszon érhető el. Pénzformázáshoz a `useMoneyFormatter()` hook
 * használja.
 */

import type { GroupLocale } from '@pta/types/group-locale';
import { apiCall } from './client';

export function fetchGroupLocale(groupId: number): Promise<GroupLocale> {
  return apiCall(`/groups/${groupId}/locale`);
}
